import { DataGrid, GridRowId, esES } from "@mui/x-data-grid";
import { FC, useState } from "react";
import useFetchTransactionStatus from "../../../../../../service/userTransactions/getTransactionsByStatus";
import { TableCustomProps } from "../../../../../../components/table/table";
import { Box, Chip } from "@mui/material";
import {
  formatearPesoMXN,
  formatFechaMexico,
} from "../../../../../../utilis/formatter";
import InfoIcon from "@mui/icons-material/Info";
import { DialogInfo } from "../../../../../../components/common/dialogInfo/DialogInfo";

interface IProps {
  setRow: React.Dispatch<any>;
}

export const GridDrawl: FC<IProps> = (props) => {
  const storedToken = sessionStorage.getItem("userData");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([]);
  const [openModal, setOpenModal] = useState(false);

  const transformDataToTable = (
    Withdrawals: any[]
  ): TableCustomProps["rows"] => {
    return Withdrawals.map((withdrawals) => ({
      id: withdrawals._id,
      email: withdrawals.email,
      amount_without_comision: withdrawals.amount,
      amount_with_comision: withdrawals.amount_bo_comision,
      updated_at: withdrawals.updated_at,
      withdrawal_status: withdrawals.withdrawal_status,
      status_description: withdrawals.status_description,
      status: withdrawals.status,
      move_id: withdrawals.move_id,
      amount: withdrawals.amount,
      date: formatFechaMexico(withdrawals?.created_at),
      amount_comision: withdrawals.comission,
    }));
  };

  const { transaction, loading } = useFetchTransactionStatus();

  const dataTable: any = {
    columns: [
      { field: "id", headerName: "ID de cobro", flex: 1, minWidth: 150 },

      { field: "email", headerName: "Cliente", flex: 1, minWidth: 150 },

      {
        field: "amount_without_comision",
        headerName: "Cargo sin comisión",
        flex: 1,
        minWidth: 150,
        renderCell: (params: { row: { amount_without_comision: any } }) => (
          <Chip
            variant="outlined"
            label={formatearPesoMXN(params.row?.amount_without_comision)}
            color="success"
          />
        ),
      },
      {
        field: "amount_with_comision",
        headerName: "Cargo con comision",
        flex: 1,
        minWidth: 150,

        renderCell: (params: { row: { amount_with_comision: any } }) => (
          <Chip
            variant="outlined"
            label={formatearPesoMXN(params.row?.amount_with_comision)}
            color="primary"
          />
        ),
      },
      {
        field: "amount_comision",
        headerName: "Comision",
        flex: 1,
        minWidth: 150,

        renderCell: (params: { row: { amount_comision: any } }) => (
          <Chip
            icon={<InfoIcon />}
            onClick={handleInfo}
            variant="outlined"
            label={formatearPesoMXN(params.row?.amount_comision || 0)}
            color="primary"
          />
        ),
      },
      { field: "date", headerName: "Fecha", flex: 1, minWidth: 150 },
    ],
    rows: transformDataToTable(transaction || []),
  };

  const onSelect = (iteam: any) => {
    setSelectionModel(iteam);
  };

  const c = dataTable.rows.filter((row: any) =>
    selectionModel.includes(row.id)
  );

  const handleInfo = () => {
    setOpenModal(true);
  };

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <DataGrid
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        loading={loading}
        rows={dataTable?.rows}
        columns={dataTable?.columns}
        rowsPerPageOptions={[5, 10, 50, 100]}
        pageSize={50}
        pagination
        disableSelectionOnClick
        checkboxSelection
        autoHeight
        disableExtendRowFullWidth
        selectionModel={selectionModel}
        onSelectionModelChange={(newSelection) => {
          setSelectionModel(newSelection);
          props.setRow(
            dataTable.rows.filter((row: any) => newSelection.includes(row.id))
          );
        }}
      />
      <DialogInfo
        title="Cálculo de la comisión aplicada"
        children={
          <Box>
            <p>
              La comisión que se cobra por cada transacción se determina de la
              siguiente manera:
            </p>
            <ol>
              <li>
                <b>Porcentaje sobre el monto: </b>Se aplica un{" "}
                <strong>3.2%</strong> sobre el valor total de la operación.
              </li>
              <li>
                <b>Cargo fijo: </b> Se añade una cuota fija de $3.00 MXN por
                transacción
              </li>
              <li>
                <b>(IVA): </b> Al subtotal obtenido (3.2% del monto + $3.00 MXN),
                se le aplica el IVA correspondiente del 1.16
              </li>
            </ol>
            <p>
              Comisión total = (3.2% del monto + $3.00) + IVA (1.16 sobre el
              subtotal)
            </p>
          </Box>
        }
        open={openModal}
        setOpen={setOpenModal}
      />
    </div>
  );
};

// const queryParams = useMemo(
//   () => ({
//     page: page + 1, // Backend normalmente usa 1-indexed
//     limit: rowsPerPage,
//     startDate: "",
//     endDate: "",
//   }),
//   [page, rowsPerPage]
// );
